@if (showSpinner()) {
  <div class="spinner-container">
    <div class="spinner-wrapper">
      <div class="spinner-border spinner text-primary" role="status"><span class="visually-hidden">Loading...</span></div>
    </div>
  </div>
}
